var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 273,
    height: 102,
    viewBox: "0 0 273 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.01465,
    width: 272,
    height: 100,
    rx: 4.5,
    fill: "",
    stroke: "#64748b85"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M137.529 44.2424L130.357 62H127.373L120.201 44.2424H122.854C123.14 44.2424 123.374 44.312 123.554 44.4512C123.734 44.5904 123.869 44.7705 123.959 44.9915L128.147 55.8229C128.286 56.175 128.417 56.5638 128.54 56.9896C128.671 57.4071 128.794 57.8451 128.908 58.3036C129.006 57.8451 129.113 57.4071 129.228 56.9896C129.342 56.5638 129.469 56.175 129.608 55.8229L133.771 44.9915C133.837 44.8032 133.964 44.6313 134.152 44.4757C134.348 44.3202 134.586 44.2424 134.864 44.2424H137.529ZM145.225 52.6914C145.847 52.6914 146.388 52.6136 146.846 52.4581C147.313 52.3025 147.693 52.0896 147.988 51.8195C148.291 51.5411 148.516 51.2136 148.663 50.837C148.811 50.4604 148.885 50.047 148.885 49.5967C148.885 48.6961 148.586 48.0043 147.988 47.5213C147.399 47.0383 146.494 46.7968 145.274 46.7968H143.162V52.6914H145.225ZM153.723 62H150.739C150.174 62 149.765 61.779 149.511 61.3369L145.778 55.651C145.638 55.4381 145.483 55.2867 145.311 55.1966C145.147 55.1066 144.902 55.0615 144.574 55.0615H143.162V62H139.858V44.2424H145.274C146.478 44.2424 147.509 44.3693 148.369 44.6231C149.237 44.8687 149.945 45.2167 150.493 45.667C151.05 46.1172 151.459 46.6576 151.721 47.288C151.983 47.9102 152.114 48.5979 152.114 49.3511C152.114 49.9487 152.024 50.5136 151.844 51.0458C151.672 51.578 151.418 52.061 151.083 52.4949C150.755 52.9288 150.346 53.3095 149.855 53.637C149.372 53.9645 148.819 54.2224 148.197 54.4107C148.41 54.5335 148.606 54.6808 148.786 54.8528C148.966 55.0165 149.13 55.213 149.278 55.4422L153.723 62Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVr);
export default __webpack_public_path__ + "static/media/VR.933407f8e5ca8d6dfc77be5eeace289e.svg";
export { ForwardRef as ReactComponent };